import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import {DataTable} from "../DataTable";
import {GridColumns} from "@mui/x-data-grid";
import {useParams} from "react-router-dom";

interface detailsTable {
    tableData : any,
    duration : string,
    skeleton : boolean,
    tableColumns : GridColumns
}



export const DetailsTable = ( { tableData, duration, skeleton, tableColumns }  : detailsTable) =>{
    return(
        <React.Fragment>
            <Typography
                fontSize={25}
                fontWeight={700}
                color="#081735"
                marginTop={4}
            >
                Details
            </Typography>
            <DataTable showFooter={false} data={tableData} duration={duration} height={400} skeleton = {skeleton} columns={tableColumns}/>
        </React.Fragment>
    )
}